











































import { Component, Vue } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import TPPClaimsModule from "@/store/modules/tpp-claims";
import { TPPClaimsState } from "@/models/store/TPPClaimsState";

const tppClaims = namespace(TPPClaimsModule.name);

@Component({
  name: "PropertyDamageInfo"
})
export default class PropertyDamageInfo extends Vue {
  // ===== Props ===== //

  // ===== Store ===== //
  @State("tppClaims") private readonly tppClaims!: TPPClaimsState;
  @tppClaims.Action("handleClaimDescribedItems") public handleClaimDescribedItems!: (payload: string) => void;
  @tppClaims.Action("handleClaimDamageDescription") public handleClaimDamageDescription!: (payload: string) => void;
  @tppClaims.Action("handleClaimEstimatedDamage") public handleClaimEstimatedDamage!: (payload: number) => void;

  // ===== Data ===== //
  public currencyDark = "background: rgba(255, 255, 255, 0.08); color: white";
  public currencyLight = "background: rgba(0,0,0,.06); color: black";

  // ===== Methods ===== //

  // ===== Computed ===== //
  get selectedTPPClaim() {
    return this.tppClaims.selectedTPPClaim;
  }

  get claimDescribedItems() {
    return this.selectedTPPClaim!.damaged_items;
  }
  set claimDescribedItems(newVal: string) {
    this.handleClaimDescribedItems(newVal);
  }

  get claimDamageDescription() {
    return this.selectedTPPClaim!.damage_description;
  }
  set claimDamageDescription(newVal: string) {
    this.handleClaimDamageDescription(newVal);
  }

  get claimEstimatedDamage() {
    return this.selectedTPPClaim!.damage_estimate;
  }
  set claimEstimatedDamage(newVal: number) {
    this.handleClaimEstimatedDamage(newVal);
  }

  // ===== Lifecycle ===== //
}
